import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import classnames from 'classnames';

import Header from '../Header';
import Container from '../Container';
import UniversityHero from '../UniversityHero';
import Image from '../Image';
import SectionHeader from '../SectionHeader';
import Footer from '../Footer';
import Cta from '../Cta';
import Goal from './Goal';
import GreenBox from './GreenBox';
import TestimonialBox from './TestimonialBox';

import styles from './universities.css';
import valuePropImage from '../images/unis-cau-value-prop.png';
import unisLogos from '../images/unis-logos.png';
import goalsOneImage from '../images/unis-goals-1.png';
import goalsTwoImage from '../images/unis-goals-2.png';
import unicornImage from '../images/unis-unicorn.png';
// Uni logos
import icbsLogo from '../images/logos/icbs.png';
import kingsLogo from '../images/logos/kings.png';
import lseLogo from '../images/logos/lse.png';
import uosLogo from '../images/logos/uos.png';

const { div, p, h2, img } = hh(h);

const content = {
    valueProp: {
        title: 'Skills-based digital training on campus',
        text: ['Code at Uni provide skills-based courses on campus that either supplement the rigorous academic education universities provide or can be integrated into an existing module. All of our courses can be run on weekends so as not to disrupt academic timetables.'],
        image: valuePropImage
    },
    logos: {
        title: 'Universities we work with',
        image: unisLogos
    },
    goals: [
        {
            className: styles.goalOne,
            image: goalsOneImage,
            title: 'Student Satisfaction',
            text: ['All universities are ranked on their level of student satisfaction as it forms a key part of the student experience. Providing activities and initiatives for students that are both valuable to their development but also engaging is key. Code at Uni was founded as a response to the perceived lack of engaging activities offered to students. Our courses consistently receive outstanding feedback from students and higher education institutions with an average NPS score of +89.']
        }, 
        {
            className: styles.goalTwo,
            image: goalsTwoImage,
            title: 'Improve Career Prospects',
            text: ['The job market is fast evolving and so are the competencies employers look for in graduates. The impact that technology is having on all graduate destinations is immense. Being able to understand and work with technology is fast-becoming a necessary skillset as employers seek to digitise their business models. Providing digital training to students is a powerful way to improve and sustain graduate career prospects as the economy evolves.']
        }
    ],
    greenBoxes: {
        title: 'The 21st century skill',
        boxes: [
            {
                alpha: '90%',
                beta: 'of UK jobs require digital literacy'
            },
            {
                alpha: '72%',
                beta: 'of LMEs suffer from a tech skill gap'
            },
            {
                alpha: unicornImage,
                beta: 'your students could build the next unicorn startup'
            }
        ]
    },
    testimonials: {
        title: 'What our partners say about us',
        boxes: [
            {
                image: icbsLogo,
                quote: '“75 Master’s students from Imperial College Business School recently attended a coding workshop, hosted by Code at Uni, where they embarked upon a fast-track introduction to coding. In a world where computer code supports businesses working across all sectors, coding is an in-demand skill for today’s graduates.”',
                link: 'https://www.imperial.ac.uk/business-school/intelligence/features/masters-students-learn-code/'
            },
            {
                image: uosLogo,
                quote: '“Marketing is becoming more and more technical and giving our students an opportunity to get some first-hand exposure to this, fully organised by a team of experts, resulted in a valuable contribution to their degree and employability.“',
                cite: 'Prof. René Moolenaar, Senior Teaching Fellow, University of Sussex.'
            },
            {
                image: kingsLogo,
                quote: '“We arranged our first course with Code at Uni earlier this year and are very happy with the collaboration – the communications, arrangements, and above all the course itself, got highly positive feedback all round. We like the dynamic energy and enthusiasm of Code at Uni and are planning to extend the relationship in the coming months.“',
                cite: 'Eve Zawadzki, School Education Manager, King\'s College London'
            },
            {
                image: lseLogo,
                quote: '“It\'s been an absolute pleasure to work with Code at Uni. The feedback from the courses over the last four years has always been outstanding and we regularly receive an onslaught of communications following a Code At Uni event from students asking when the next course is taking place! Couldn\'t recommend these guys more!“',
                cite: 'Laura-Jane Silverman, LSE Career Services'
            }
        ]
    }
};


const Universities = (props) => {

    return (
        div({className: styles.universities}, [
            h(Header),

            // Hero
            h(Container, {size: 'big', theme: 'unis'}, h(UniversityHero)),

            // Opening section
            h(Container, { className: classnames(styles.openerValue, styles.unisSection) }, [
                div({className: styles.openerValueText}, [
                    h2(content.valueProp.title),
                    p(content.valueProp.text)
                ]),
                div({className: styles.openerValueImage}, [img({ src: content.valueProp.image, alt: '' })])
            ]),

            // Unis logos
            h(Container, { className: classnames(styles.logos, styles.unisSection), size: 'big'}, [
                h(SectionHeader, { classes: [styles.unisSectionTitle] }, content.logos.title),
                h(Image, {src: content.logos.image, alt: 'Universities we work with'})
            ]),

            // Your goals section
            h(Container, { className: classnames(styles.goals), size: 'big'}, content.goals.map(g => h(Goal, g))),

            // Green boxes
            h(Container, { className: classnames(styles.unisSection), size: 'big'}, [
                h(SectionHeader, { classes: [styles.unisSectionTitle] }, content.greenBoxes.title),
                div({ className: styles.greenBoxes }, content.greenBoxes.boxes.map(box => h(GreenBox, box)) )
            ]),

            // What our partners say
            h(Container, { className: classnames(styles.testimonials), size: 'big'}, [
                h(SectionHeader, { classes: [styles.unisSectionTitle] }, content.testimonials.title),
                h('div', { className: styles.testimonialsGrid }, content.testimonials.boxes.map(box => h(TestimonialBox, box)))
            ]),

            // Final cta
            h(Container, { className: classnames(styles.unisSection), size: 'big'}, [
                h(SectionHeader, { classes: [styles.unisSectionTitle] }, 'Should we come to your school?'),
                h(Cta, { to: '/contact' }, 'Contact us')
            ]),

            h(Container, [
                h(Footer)
            ])
        ])
    );
};

export default Universities;



/** WEBPACK FOOTER **
 ** ./src/Universities/index.js
 **/